import * as React from "react";
import { SVGProps } from "react";

const SvgSixHearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 247 347"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M237.4.8H9.8S.2 1.1.2 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h227.7s9.5-.3 9.5-12.9V13.7C247 1.1 237.4.8 237.4.8Z"
      fill="#fff"
    />
    <mask
      id="six-hearts_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={187}
      width={247}
      height={160}
    >
      <path
        d="M145.7 187.2H.2v146.1c0 12.6 9.6 12.9 9.6 12.9h227.6s9.5-.3 9.5-12.9V187.2H145.7Z"
        fill="url(#six-hearts_svg__a)"
      />
    </mask>
    <g mask="url(#six-hearts_svg__b)">
      <path
        d="M145.7 187.2H.2v146.1c0 12.6 9.6 12.9 9.6 12.9h227.6s9.5-.3 9.5-12.9V187.2H145.7Z"
        fill="url(#six-hearts_svg__c)"
      />
    </g>
    <mask
      id="six-hearts_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={247}
      height={174}
    >
      <path
        d="M.3 173.1H247V13.7C247 1.1 237.5.8 237.5.8H9.8S.2 1.1.2 13.7v159.4h.1Z"
        fill="url(#six-hearts_svg__d)"
      />
    </mask>
    <g mask="url(#six-hearts_svg__e)">
      <path
        d="M.3 173.1H247V13.7C247 1.1 237.5.8 237.5.8H9.8S.2 1.1.2 13.7v159.4h.1Z"
        fill="url(#six-hearts_svg__f)"
      />
    </g>
    <mask
      id="six-hearts_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M246.5 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.5-.3 9.5-12.9V13.7c0-12.6-9.5-12.9-9.5-12.9h-.5s9.6.3 9.6 12.9Z"
        fill="url(#six-hearts_svg__g)"
      />
    </mask>
    <g mask="url(#six-hearts_svg__h)">
      <path
        d="M246.5 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.5-.3 9.5-12.9V13.7c0-12.6-9.5-12.9-9.5-12.9h-.5s9.6.3 9.6 12.9Z"
        fill="url(#six-hearts_svg__i)"
      />
    </g>
    <mask
      id="six-hearts_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M.8 333.4V14.2c0-12.6 9.6-12.9 9.6-12.9H238.3s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H9.8S.2 1.1.2 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h.5c0-.1-9.5-.3-9.5-12.9Z"
        fill="url(#six-hearts_svg__j)"
      />
    </mask>
    <g mask="url(#six-hearts_svg__k)">
      <path
        d="M.8 333.4V14.2c0-12.6 9.6-12.9 9.6-12.9H238.3s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H9.8S.2 1.1.2 13.7v319.7c0 12.6 9.6 12.9 9.6 12.9h.5c0-.1-9.5-.3-9.5-12.9Z"
        fill="url(#six-hearts_svg__l)"
      />
      <mask
        id="six-hearts_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={1}
        height={299}
      >
        <path
          d="M.2 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.1-1.8-.3-3.6-.5-5.4Z"
          fill="url(#six-hearts_svg__m)"
        />
      </mask>
      <g mask="url(#six-hearts_svg__n)">
        <path
          d="M.2 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.1-1.8-.3-3.6-.5-5.4Z"
          fill="url(#six-hearts_svg__o)"
        />
      </g>
    </g>
    <path
      d="M26.4 67.5c-5.1 3.8-7.7 7.7-7.8 7.8-.1-.1-2.6-4.1-7.8-7.8-5.2-3.8-6.4-8.6-4.5-12.2 1.9-3.6 9.3-5.4 12.3 1.8 3-7.2 10.4-5.4 12.3-1.8 1.9 3.6.8 8.4-4.5 12.2ZM25.9 16.8v1.1c-2.2 0-4.2.5-6 1.4-1.7 1-3.2 2.4-4.3 4.2-1.1 1.9-1.9 4.1-2.4 6.6l.2.1c1.2-.9 2.4-1.5 3.6-1.9 1.2-.4 2.5-.6 3.9-.6 1.6 0 3 .4 4.2 1.1 1.2.7 2 1.7 2.6 3 .6 1.3.9 2.8.9 4.6 0 1.9-.4 3.6-1.1 5-.7 1.4-1.9 2.6-3.4 3.4-1.5.8-3.4 1.2-5.6 1.2-3.2 0-5.6-1-7.2-3-1.6-2-2.4-4.9-2.4-8.7 0-2.6.4-5 1.2-7.3.8-2.3 2-4.2 3.5-5.9 1.5-1.7 3.2-3 5.2-4s4.1-1.5 6.2-1.6l.9 1.3ZM19.4 30c-.7 0-1.4.1-2.1.2-.7.2-1.3.4-1.9.7-.6.3-1.1.7-1.7 1.2-.2.2-.3.3-.4.5-.1.3-.2.6-.3 1 0 .4-.1 1.1-.1 2 0 2.8.5 4.9 1.4 6.3.9 1.5 2.3 2.2 4.2 2.2 1.1 0 2-.2 2.7-.6.7-.4 1.3-.9 1.8-1.6.5-.7.8-1.4 1-2.3.2-.9.3-1.9.3-2.9 0-2.2-.4-3.8-1.3-5-.8-1.1-2-1.7-3.6-1.7ZM219.5 279c5.1-3.8 7.7-7.7 7.8-7.8.1.1 2.6 4.1 7.8 7.8 5.2 3.8 6.4 8.6 4.5 12.2-1.9 3.6-9.3 5.4-12.3-1.8-3 7.2-10.4 5.4-12.3 1.8-1.9-3.6-.8-8.4 4.5-12.2ZM220 329.7v-1.1c2.2 0 4.2-.5 6-1.4 1.7-1 3.2-2.4 4.3-4.2 1.1-1.9 1.9-4.1 2.4-6.6l-.2-.1c-1.2.9-2.4 1.5-3.6 1.9-1.2.4-2.5.6-3.8.6-1.6 0-3-.4-4.2-1.1-1.2-.7-2-1.7-2.6-3-.6-1.3-.9-2.8-.9-4.6 0-1.9.4-3.6 1.1-5 .7-1.4 1.9-2.6 3.4-3.4 1.5-.8 3.4-1.2 5.6-1.2 3.2 0 5.6 1 7.2 3 1.6 2 2.4 4.9 2.4 8.7 0 2.6-.4 5-1.2 7.3-.8 2.3-2 4.2-3.5 5.9-1.5 1.7-3.2 3-5.2 4s-4.1 1.5-6.2 1.6l-1-1.3Zm6.5-13.3c.7 0 1.4-.1 2.1-.2.7-.2 1.3-.4 1.9-.7.6-.3 1.1-.7 1.7-1.2.2-.2.3-.3.4-.5.1-.3.2-.6.3-1 0-.4.1-1.1.1-2.1 0-2.8-.5-4.9-1.4-6.3-.9-1.5-2.3-2.2-4.2-2.2-1.1 0-2 .2-2.7.6-.7.4-1.3.9-1.8 1.6-.5.7-.8 1.4-1 2.3-.2.9-.3 1.9-.3 2.9 0 2.2.4 3.8 1.3 5 .8 1.2 2 1.8 3.6 1.8ZM93.8 82.4c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.4 16.7-9 24.2ZM63 264c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.1-1.4-16.6 9-24.2ZM184.9 82.4c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.4 16.7-9 24.2ZM93.8 180.7c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.1 1.4 16.6-9 24.2ZM184.9 180.7c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.1 1.4 16.6-9 24.2ZM154.1 264c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.2-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.1-1.4-16.6 9-24.2Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="six-hearts_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119.808 -116.964) scale(499.516)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119.808 -116.964) scale(499.516)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124.75 319.576) scale(357.936)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(124.75 319.576) scale(357.936)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.3 .645) scale(397.434)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.3 .645) scale(397.434)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.652 101.335) scale(338.507)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.652 101.335) scale(338.507)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.857 .322) scale(397.537)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="six-hearts_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.857 .322) scale(397.537)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgSixHearts;
